import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store';
import { observer } from 'mobx-react-lite';
import withUser from '../../hoc/withUser';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/solid';

const StatusIndicator = ({ status, label }) => (
  <h3 className="my-1" style={{ fontSize: '1.125rem' }}>
    <span className="mr-2">{label}</span>
    {status === 'Healthy' ? (
      <CheckCircleIcon style={{ height: 24, width: 24, color: 'green' }} />
    ) : (
      <XCircleIcon style={{ height: 24, width: 24, color: 'red' }} />
    )}
  </h3>
);

const ServicesStatusPage = observer(({ user, authToken }) => {
  const {
    rootStore: {
      profileStore,
      profileStore: { serviceStatusesStore },
    },
  } = useStore();
  const { i18n } = useTranslation();

  useEffect(() => {
    serviceStatusesStore.loadingServiceStatuses = true;
    const getServiceStatuses = async () => {
      if (!profileStore.profileData) {
        await profileStore.initProfile(user, authToken, i18n);
      }

      await serviceStatusesStore.getServiceStatuses();
    };

    getServiceStatuses().then(() => (serviceStatusesStore.loadingServiceStatuses = false));

    return () => serviceStatusesStore.resetServiceStatuses();
  }, [serviceStatusesStore, authToken, i18n, profileStore, user]);

  const serviceStatuses = serviceStatusesStore.serviceStatuses;

  let content;
  if (serviceStatusesStore.loadingServiceStatuses) {
    content = <h3 style={{ fontSize: '1.125rem' }}>Loading...</h3>;
  } else if (serviceStatusesStore.error) {
    content = (
      <>
        <p className="heading">Services Health Status</p>
        <StatusIndicator
          label="Overall status"
          status={serviceStatusesStore.error?.response?.data?.overallStatus || 'Unhealthy'}
        />
        <StatusIndicator label="API" status={'Unhealthy'} />
        <p>Error: {serviceStatusesStore.error?.message} (myFeller API fails, can't retrieve service statuses)</p>
      </>
    );
  } else {
    content = (
      <>
        <h1 style={{ fontSize: '2rem ' }}>Services Health Status </h1>
        <StatusIndicator label="Overall status" status={serviceStatuses.overallStatus} />
        <br />
        <StatusIndicator label="API" status={serviceStatuses.fellerApi} />
        <StatusIndicator
          label="Database"
          status={
            serviceStatuses.dynamoDbDatabase === 'Healthy' && serviceStatuses.mySqlDbDatabase === 'Healthy'
              ? 'Healthy'
              : 'Unhealthy'
          }
        />
        <StatusIndicator label="Mailing API" status={serviceStatuses.mandrillApi} />
        <StatusIndicator label="Authentication API" status={serviceStatuses.auth0Api} />
        <StatusIndicator
          label="Training API"
          status={
            serviceStatuses.lernetzApiStatus === 'Healthy' && serviceStatuses.lernetzApiStatus === 'Healthy'
              ? 'Healthy'
              : 'Unhealthy'
          }
        />
        <StatusIndicator label="MoneyHouse API(Active swiss companies)" status={serviceStatuses.moneyhouseApiStatus} />
        <StatusIndicator label="Email Subscription API" status={serviceStatuses.mailchimpApiStatus} />
        <StatusIndicator label="SMS API" status={serviceStatuses.twilioApiStatus} />
      </>
    );
  }

  return <div className="mx-5 my-5">{content}</div>; //
});

export default withUser(ServicesStatusPage);
